import { useEffect, useRef, useSyncExternalStore } from "react";

/* The nav bar shows the page's title + count (and optional Play/Shuffle) once its <h1> has scrolled under the bar. */
let state = { title: "", meta: "", past: false, actions: null };
const subs = new Set();
const set = (patch) => { state = { ...state, ...patch }; subs.forEach((fn) => fn()); };
export const useBarTitle = () => useSyncExternalStore((fn) => { subs.add(fn); return () => subs.delete(fn); }, () => state);

const BAR_PX = 64;

/* Attach to a page heading: returns a ref for the <h1>. `actions` = { play, shuffle, disabled?, starred?, onStar? } for quick controls. */
export const useHeadingRef = (title, meta, actions) => {
  const ref = useRef(null);
  const latest = useRef(actions);
  latest.current = actions;
  const has = !!actions;
  const disabled = !!actions?.disabled;
  const starred = actions?.starred;
  const canStar = typeof actions?.onStar === "function";
  useEffect(() => { set({ title: title || "", meta: meta || "" }); }, [title, meta]);
  useEffect(() => {
    set({ actions: has ? { play: () => latest.current?.play?.(), shuffle: () => latest.current?.shuffle?.(), disabled,
      onStar: canStar ? () => latest.current?.onStar?.() : null, starred: !!starred } : null });
  }, [has, disabled, canStar, starred]);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => set({ past: !e.isIntersecting && e.boundingClientRect.top < BAR_PX }),
      { rootMargin: `-${BAR_PX}px 0px 0px 0px`, threshold: 0 });
    io.observe(el);
    return () => { io.disconnect(); set({ title: "", meta: "", past: false, actions: null }); };
  }, [title]);
  return ref;
};
